import { useMemo } from 'react';
import socialMediaContentService from '../services/socialMediaContentService';

export const useSocialMediaContentService = () => {
    return useMemo(() => {
        return {
            ...socialMediaContentService,
            getAllContent: () => socialMediaContentService.getAllContent(),
            getActiveContent: () => socialMediaContentService.getActiveContent(),
            createContent: (data: any) => socialMediaContentService.createContent(data),
            uploadAsset: (file: File) => socialMediaContentService.uploadAsset(file),
            updateContent: (id: number, data: any) => socialMediaContentService.updateContent(id, data),
            deleteContent: (id: number) => socialMediaContentService.deleteContent(id),
            submitForApproval: (id: number) => socialMediaContentService.submitForApproval(id),
            approveContent: (id: number) => socialMediaContentService.approveContent(id),
            rejectContent: (id: number, reason: string) => socialMediaContentService.rejectContent(id, reason),
            publishContent: (id: number) => socialMediaContentService.publishContent(id),
            startCampaign: (id: number) => socialMediaContentService.startCampaign(id),
            pauseCampaign: (id: number) => socialMediaContentService.pauseCampaign(id),
            stopCampaign: (id: number) => socialMediaContentService.stopCampaign(id),
            getAnalyticsOverview: (filters?: { days?: number; fromDate?: string; toDate?: string; platform?: string }) =>
                socialMediaContentService.getAnalyticsOverview(filters),
            listConnectPlatforms: () => socialMediaContentService.listConnectPlatforms(),
            registerConnectPlatform: (payload: { platformCode: string; displayLabel: string; providerKey: string }) =>
                socialMediaContentService.registerConnectPlatform(payload),
            removeConnectPlatform: (platformCode: string) => socialMediaContentService.removeConnectPlatform(platformCode),
            connectPlatform: (platform: string) => socialMediaContentService.connectPlatform(platform),
            getConnections: () => socialMediaContentService.getConnections(),
            disconnectPlatform: (platform: string) => socialMediaContentService.disconnectPlatform(platform),
            getPublishStatus: (contentId: number) => socialMediaContentService.getPublishStatus(contentId),
            retryPublishJob: (jobId: number) => socialMediaContentService.retryPublishJob(jobId),
            getPlatformPublishMode: (platform: string) => socialMediaContentService.getPlatformPublishMode(platform),
            setPlatformPublishMode: (platform: string, publishMode: 'simulated' | 'live') =>
                socialMediaContentService.setPlatformPublishMode(platform, publishMode)
        };
    }, []);
};

export default useSocialMediaContentService; 